import Employ from 'pages/employmanagment/employ';
export const Employes = () => {
  return <Employ />;
};
